import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';
import useAuth from 'portal/src/auth/useAuth';
import WorkOrders from 'portal/src/components/administration/WorkOrders';
import forbiddenResponse from 'portal/src/navigation/responses/forbiddenResponse';

import { isWorkOrderViewEnabled } from './adminViewEnabled';

export default function WorkOrdersView(): React.ReactElement {
  const { featureChecker } = useAuth();

  if (!isWorkOrderViewEnabled({ featureChecker } as IAuthorizationContext)) {
    throw forbiddenResponse();
  }

  return <WorkOrders />;
}
